import { useAuth } from "@/hooks/useAuth";
import { hasRole } from "@/utils/roleUtils";

export type Workspace = "achiever" | "advisor";

/**
 * Which workspace the user is currently viewing the app as. Dual-role users
 * (holding both achiever and advisor) must be routed by this, not by
 * hasRole() alone -- hasRole() is true for both roles simultaneously once a
 * user is dual-role, so branching on it directly always resolves to the same
 * workspace's content regardless of which sidebar tab (WorkspaceToggle) is
 * actually active.
 *
 * Falls back to hasRole(user, "advisor") only for the brief window before
 * /users/me has loaded (activeWorkspace not yet known).
 */
export function useActiveWorkspace(): Workspace {
  const { user } = useAuth();
  if (user?.activeWorkspace === "advisor" || user?.activeWorkspace === "achiever") {
    return user.activeWorkspace;
  }
  return hasRole(user, "advisor") ? "advisor" : "achiever";
}
